import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListRewardCoupon from "../Components/Reward Coupon/listRewardCoupon";
import AddRewardCoupon from "../Components/Reward Coupon/addRewardCoupon";
import ViewRewardCoupon from "../Components/Reward Coupon/viewRewardCoupon";
import EditRewardCoupon from "../Components/Reward Coupon/editRewardCoupon";

const RewardCouponRoutes = () => {

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
  const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

  return (
    <Routes>
      <Route
        path="/reward_coupon"
        element={<ListRewardCoupon />}
      />
      <Route
        path="/reward_coupon/add"
        element={canAdd ? <AddRewardCoupon /> : <Navigate to="/reward-coupon" replace />}
      />
      <Route
        path="/reward_coupon/view/:id"
        element={<ViewRewardCoupon />}
      />
      <Route
        path="/reward_coupon/edit/:id"
        element={canEdit ? <EditRewardCoupon /> : <Navigate to="/reward-coupon" replace />}
      />
    </Routes>
  );
};

export default RewardCouponRoutes;